/* unplugin-vue-components disabled */import script from "./sourceCover.vue?vue&type=script&setup=true&lang=js"
export * from "./sourceCover.vue?vue&type=script&setup=true&lang=js"

import "./sourceCover.vue?vue&type=style&index=0&id=35448e8b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35448e8b"]])

export default __exports__